export default "__VITE_ASSET__DsxopXS6__"